module.exports = __webpack_public_path__ + "img/thumb-collection-distribuicao.0dce5fc7.jpeg";